import Base from './Base';

class Pages extends Base {
    findByPath(path, opts = null) {
        return this.getJSONWithSession(`${path}.json`, null, opts).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Pages;
